// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".top[data-v-be87e488] {\n  position: relative;\n}\n.promo[data-v-be87e488] {\n  max-width: 530px;\n  margin-left: auto;\n  margin-right: auto;\n  width: 100%;\n  display: block;\n}\n.title[data-v-be87e488] {\n  color: #654c93;\n  font-weight: 900;\n  font-size: 2.2rem;\n  text-align: center;\n  line-height: 1.3;\n  margin-top: 5vh;\n}\n.absolute[data-v-be87e488] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
